import React, { useState } from "react";
import { ArrowUp02Icon } from "hugeicons-react";
import "./ScrollToTop.css";

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <div>
      {visible ? (
        <button onClick={scrollToTop} className="goTop">
          <ArrowUp02Icon size={24} color={"white"} variant={"stroke"} />
        </button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ScrollButton;
